import { type CSSProperties, type ReactNode } from 'react'
import styles from './MobileEntityList.module.css'

type MobileEntityRowProps = {
  actions?: ReactNode
  ariaLabel?: string
  className?: string
  leading?: ReactNode
  leadingWidth?: number
  media?: ReactNode
  onSelect?: () => void
  rowHeight?: number
  subtitle?: ReactNode
  title: ReactNode
}

export const MobileEntityRow = ({
  actions,
  ariaLabel,
  className,
  leading,
  leadingWidth,
  media,
  onSelect,
  rowHeight,
  subtitle,
  title
}: MobileEntityRowProps) => {
  const style = {
    '--mobile-entity-leading-width': leadingWidth ? `${leadingWidth}px` : undefined,
    '--mobile-entity-row-height': rowHeight ? `${rowHeight}px` : undefined
  } as CSSProperties
  const bodyClassName = [styles.body, onSelect ? '' : styles.bodyStatic].filter(Boolean).join(' ')
  const bodyContent = (
    <>
      {media && <span className={styles.media}>{media}</span>}
      <span className={styles.copy}>
        <span className={styles.title}>{title}</span>
        {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
      </span>
    </>
  )

  return (
    <article className={[styles.row, className].filter(Boolean).join(' ')} style={style}>
      <div className={styles.leading}>
        {leading}
      </div>
      {onSelect ? (
        <button className={bodyClassName} onClick={onSelect} type="button" aria-label={ariaLabel}>
          {bodyContent}
        </button>
      ) : (
        <div className={bodyClassName} aria-label={ariaLabel}>
          {bodyContent}
        </div>
      )}
      <div className={styles.actions}>
        {actions}
      </div>
    </article>
  )
}
